import * as envConfig from 'config';
import * as common from './common';

import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import type {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
} from '@reduxjs/toolkit/query';


const baseQuery = fetchBaseQuery({
    baseUrl: envConfig.HOST_URL,
    mode: 'cors',
    prepareHeaders: (headers, args) => {
        const token = localStorage.getItem('jwtToken');
        
        if (args.endpoint === 'loginPost') {
            return headers;
        } else  if (token) {
            headers.set('Authorization', token);
            return headers;
        } else {
            // 로그인 필요
        }
    }
});


const baseQueryWithReauth : BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args:any, api, extraOptions) => {
    if (!args.options || !args.options.noLoading) {
        common.showLoading(true);
    }

    let result = await baseQuery(args, api, extraOptions);
    
    if (result.error) {
        common.showLoading(false);
        
        if (result.error.status === 401) {
            const param = {
                title : '확인',
                contents: '로그인 세션이 만료되었습니다.<br/>로그인 페이지로 이동합니다.',
                accept: () => {
                    common.logout();
                }
            };

            common.openError(param);
        }
    } else {
        common.showLoading(false);
        return result;
    }

}


const baseQueryWithRetry = retry(baseQueryWithReauth, { maxRetries: 0 });

export const api = createApi({
    reducerPath: 'splitApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['Post', 'Counter', 'Posts', 'Cluster', 'Sys', 'Get'],
    endpoints: () => ({
        
    })
});
